<div class="mb-3 row">
	<label class="col-md-6">For safety, all operations require you to confirm Server ID here:</label>
	<div class="col-md-6">
		<input [(ngModel)]="confirmOBCU" type="text" class="form-control">
	</div>
</div>
<hr class="my-4">
<h5>Reset the communication key</h5>
<p class="message-warning">This will generate a new, random communication key for the asset. Note that if the OBCU is currently connecting successfully, this will break it until
	the configuration is updated with the new communication key</p>
<div class="mb-3 row">
	<div class="col-md-6 offset-md-3">
		<app-action-button [action]="ResetAuth" [context]="this" processing="Resetting..." complete="Communication key reset" btnClass="red block"
			confirm="Are you sure? You will need to change the OBCU config">Reset communication key
		</app-action-button>
	</div>
</div>
@if (resetAssetAuth) {
	<div>
		<p class="message-good">The asset has been reset, with the communication key below. Copy this key and save
			it to the OBCU config. You will not be able to come back and look it up again.</p>
		<div class="mb-3 row">
			<label class="col-md-4">Asset communication key</label>
			<div class="col-md-8">{{resetAssetAuth}}</div>
		</div>
	</div>
}
<hr class="my-4">
<h5>Move to another organization</h5>
<p class="message-warning">This will move this asset to another organization. It will not be placed in a fleet - the fleet will have to be assigned after the move. The
	configuration will have to be reselected as configs are not shared across organizations.</p>
<select class="form-control" [(ngModel)]="selectedOrganization">
	@for (org of organizations; track org) {
		<option [ngValue]="org">
			{{org.name}}
		</option>
	}
</select>
<div class="mb-3 row my-3">
	<div class="col-md-6 offset-md-3">
		<app-action-button [action]="MoveAsset" [context]="this" [disabled]="!selectedOrganization" processing="Moving..." complete="Asset moved" btnClass="red block">Move
			asset</app-action-button>
	</div>
</div>
<hr class="my-4">
<h5>Delete an acquisition</h5>
<p class="message-warning">This will PERMANENTLY delete this acquisition from the database. This includes all HIs, CIs, RAWs, etc that are attached to the acquisition. This is
	not undoable. You must confirm by typing in the Server ID above. You will need to recalculate states ("Recalculate data" tab) afterwards.</p>
@if (!asset.is_fixed) {
	<div class="mb-3 row">
		<label class="col-md-4">Operation:</label>
		<div class="col-md-8">
			<select class="form-control op-list" [(ngModel)]="operationForAcq" (ngModelChange)="ListAcquisitions()"
				title="Showing {{ assetOps && assetOps.length >= ADMIN_OPERATIONS_LIMIT ? 'latest ' + ADMIN_OPERATIONS_LIMIT : 'all' }} operations">
				@for (operation of assetOps; track operation) {
					<option [ngValue]="operation" [class]="GetOpClass(operation)">
						{{operation | operationlabel : asset.time_offset_hours : true : true}}
					</option>
				}
			</select>
		</div>
	</div>
}
@if (asset.is_fixed) {
	<div class="mb-3 row">
		<label class="col-md-4">Date (UTC):</label>
		<div class="col-md-8">
			<app-day-picker [(ngModel)]="dateForAcq" (ngModelChange)="ListAcquisitions()"></app-day-picker>
		</div>
	</div>
}
<div class="mb-3 row">
	<label class="col-md-4">Component:</label>
	<div class="col-md-8">
		<select class="form-control op-list" [(ngModel)]="componentForAcq" (ngModelChange)="ListAcquisitions()">
			@for (component of componentList; track component) {
				<option [ngValue]="component">
					{{component.name}} ({{component.id}})
				</option>
			}
		</select>
	</div>
</div>
@if (acquisitionList) {
	<div class="mb-3 row">
		<label class="col-md-4">Acquisition:</label>
		<div class="col-md-8">
			<select class="form-control op-list" [(ngModel)]="acquisitionToDelete">
				@for (acquisition of acquisitionList; track acquisition) {
					<option [ngValue]="acquisition">
						{{acquisition.timestamp | datetime : "offset" : asset.time_offset_hours}} Comp: {{acquisition.component_key}}
					</option>
				}
			</select>
		</div>
	</div>
}
<div class="mb-3 row my-3">
	<div class="col-md-6 offset-md-3">
		<app-action-button [action]="DeleteAcquisition" [context]="this" [disabled]="!acquisitionToDelete" processing="Deleting..." complete="Acquisition deleted"
			btnClass="red block">Delete this acquisition</app-action-button>
	</div>
</div>
<hr class="my-4">
<h5>Delete an operation</h5>
<p class="message-warning">This will PERMANENTLY delete this operation from the database. This includes all HIs, CIs, ACSTATEs, RAWs, etc that are attached to the operation. This
	is not undoable. You must confirm by typing in the Server ID above. You will need to recalculate states ("Recalculate data" tab) afterwards.</p>
<select class="form-control op-list" [(ngModel)]="operationToDelete"
	title="Showing {{ assetOps && assetOps.length >= ADMIN_OPERATIONS_LIMIT ? 'latest ' + ADMIN_OPERATIONS_LIMIT : 'all' }} operations">
	@for (operation of assetOps; track operation) {
		<option [ngValue]="operation" [class]="GetOpClass(operation)">
			{{operation | operationlabel : asset.time_offset_hours : true : true}}
		</option>
	}
</select>
<div class="mb-3 row my-3">
	<div class="col-md-6 offset-md-3">
		<app-action-button [action]="DeleteOperation" [context]="this" [disabled]="!operationToDelete" processing="Deleting..." complete="Operation deleted" btnClass="red block">Delete
			this ENTIRE operation</app-action-button>
	</div>
</div>
<hr class="my-4">
<h5>Clean up data</h5>
<p class="message-warning">This will PERMANENTLY delete all matching acquisitions from the database. This is not undoable. You must confirm by typing in the Server ID above. You
	will need to recalculate states ("Recalculate data" tab) afterwards.</p>
<div class="mb-3 row">
	<label class="col-md-4">Start Date (UTC):</label>
	<div class="col-md-8">
		<app-day-picker [(ngModel)]="cleanupStartDate"></app-day-picker>
	</div>
</div>
<div class="mb-3 row">
	<label class="col-md-4">End Date (UTC):</label>
	<div class="col-md-8">
		<app-day-picker [(ngModel)]="cleanupEndDate"></app-day-picker>
	</div>
</div>
<div class="mb-3 row">
	<label class="col-md-4">Component:</label>
	<div class="col-md-8">
		<select class="form-control op-list" [(ngModel)]="cleanupComponent">
			<option [ngValue]="null">All components</option>
			@for (component of componentList; track component) {
				<option [ngValue]="component">
					{{component.name}} ({{component.id}})
				</option>
			}
		</select>
	</div>
</div>
<div class="mb-3 row">
	<label class="col-md-4">HI Limit:</label>
	<div class="col-md-8">
		<input [(ngModel)]="cleanupHiLimit" name="cleanupHiLimit" step=".001" type="number" class="form-control">
	</div>
</div>
<div class="mb-3 row my-3">
	<div class="col-md-6 offset-md-3">
		<app-action-button [action]="CleanupData" [context]="this" [disabled]="!cleanupStartDate || !cleanupEndDate || !cleanupHiLimit" processing="Deleting..."
			btnClass="red block">Delete ALL matching acquisitions</app-action-button>
	</div>
</div>
<hr class="my-4">
<h5>Delete all data</h5>
<p class="message-warning">This is PERMANENT and will delete ALL DATA associated with the selected asset. This includes all operations, acquisitions, and raw data. This is not
	undoable. You must confirm by typing in the Server ID above.</p>
<div class="mb-3 row">
	<div class="col-md-6 offset-md-3">
		<app-action-button [action]="WipeAsset" [context]="this" processing="Wiping..." complete="Asset wiped" btnClass="red block"
			confirm="Are you sure? This will permanently delete all asset data">Wipe ALL DATA for this asset</app-action-button>
	</div>
</div>
<div>
	@if (wipeStatus) {
		<p>
			<ngb-progressbar type="success" [value]="wipeProgress"></ngb-progressbar>
		</p>
	}
	{{wipeStatus}}
</div>
<hr class="my-4">
<h5>Delete this asset entirely</h5>
<p class="message-warning">This is PERMANENT and will delete the entire asset. This includes the OBCU login
	information. This is not undoable. You must confirm by typing in the Server ID above.</p>
<p class="message-warning">You MUST first wipe all data using the "Delete all data" section above. If any operations remain, this will fail.</p>
<div class="mb-3 row">
	<div class="col-md-6 offset-md-3">
		<app-action-button [action]="DeleteAsset" [context]="this" processing="Deleting..." complete="Asset deleted" btnClass="red block"
			confirm="Are you sure? This will permanently delete the asset and all data">Delete this asset and ALL DATA</app-action-button>
	</div>
</div>